import { DOCTYPE_ADDRESS_TYPE, DOCTYPE_COUNTRY } from '@krispsystems/constants';
import {
  SET_USER_ROLE_AUTHORITY_LIST,
  SET_ENTITY_TYPE_LIST,
  SET_INVENTORY_STATUS_LIST,
  SET_TRANSACTION_STATUS_LIST,
  SET_DEVICE_STATUS_LIST,
  SET_ADDRESS_TYPE_LIST,
  SET_COUNTRY_LIST,
} from '../constants/constant_action_types';

const INITIAL_STATE = {
  entity_type: [],
  inventory_status: [],
  transaction_status: [],
  employee_role_authority: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_ENTITY_TYPE_LIST: {
      return {
        ...state,
        entity_type: action.payload,
      };
    }
    case SET_INVENTORY_STATUS_LIST: {
      return {
        ...state,
        inventory_status: action.payload,
      };
    }
    case SET_TRANSACTION_STATUS_LIST: {
      return {
        ...state,
        transaction_status: action.payload,
      };
    }
    case SET_DEVICE_STATUS_LIST: {
      return {
        ...state,
        device_status: action.payload,
      };
    }
    case SET_USER_ROLE_AUTHORITY_LIST: {
      return {
        ...state,
        user_role_authority: action.payload,
      };
    }
    case SET_ADDRESS_TYPE_LIST: {
      return {
        ...state,
        [DOCTYPE_ADDRESS_TYPE]: action.payload,
      };
    }
    case SET_COUNTRY_LIST: {
      return {
        ...state,
        [DOCTYPE_COUNTRY]: action.payload,
      };
    }
    default:
      return state;
  }
}
